import { useWindowDimensions } from './useWindowDimensions'

export const useMobileView = () => {
  const { width } = useWindowDimensions()

  // Return true if width is less than 800, otherwise false
  return width < 800
}
